import gql from 'graphql-tag';

const LIST_ORGS_TREE = gql`
  query listOrgsTree($parentid: ID!, $skip: Int, $first: Int) {
    orgs(
      first: $first
      skip: $skip
      where: { OR: [{ parentOrg_some: { id: $parentid } }, { id: $parentid }] }
      orderBy: name_ASC
    ) {
      id
      name
      parentOrg {
        id
        name
        level
      }
      config {
        isAdmin
      }
      roles(first: 1, where: { isMaster: true }) {
        id
        isMaster
        roleItems(first: 15) {
          id
          feature
          actions
        }
      }
    }
  }
`;

export default LIST_ORGS_TREE;
